// extracted by mini-css-extract-plugin
export default {"container":"card_container__U5bju","description":"card_description__RDu6l"};